import axios from 'axios';

export class GroupService {
    getGroupById = async (id) => {
        return await axios.get('/api/group/getgroupbyid?id=' + id);
    };

    getGroups = async () => {
        return await axios.get('/api/group');
    };
        
    saveGroup = async (vm) => {
        return await axios.post('/api/group/savegroup', vm);
    }

    deleteGroup = async (id) => {
        return await axios.delete('/api/group?id=' + id);
    }
}